/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * * `Allow` - Allow
 * * `Deny` - Deny
 */
export var PermissionTypeEnum;
(function (PermissionTypeEnum) {
    PermissionTypeEnum["Allow"] = "Allow";
    PermissionTypeEnum["Deny"] = "Deny";
})(PermissionTypeEnum || (PermissionTypeEnum = {}));
/**
 * * `Professional` - Professional
 * * `Business` - Business
 * * `Enterprise` - Enterprise
 */
export var LevelEnum;
(function (LevelEnum) {
    LevelEnum["Professional"] = "Professional";
    LevelEnum["Business"] = "Business";
    LevelEnum["Enterprise"] = "Enterprise";
})(LevelEnum || (LevelEnum = {}));
/**
 * * `torqflow` - TorqFlow
 * * `torqdata` - TorqData
 * * `torqnlp` - TorqNLP
 * * `torqagent` - TorqAgent
 * * `torqanalytics` - TorqAnalytics
 * * `torqsecure` - TorqSecure
 * * `custom_user_app` - Custom User App
 */
export var AppTypeEnum;
(function (AppTypeEnum) {
    AppTypeEnum["Torqflow"] = "torqflow";
    AppTypeEnum["Torqnlp"] = "torqnlp";
    AppTypeEnum["Torqagent"] = "torqagent";
    AppTypeEnum["Torqanalytics"] = "torqanalytics";
    AppTypeEnum["Torqsecure"] = "torqsecure";
    AppTypeEnum["CustomUserApp"] = "custom_user_app";
})(AppTypeEnum || (AppTypeEnum = {}));
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["JsonApi"] = "application/vnd.api+json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = 'https://api.torqcloud.io';
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: 'same-origin',
            headers: {},
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
            [ContentType.JsonApi]: (input) => input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
            [ContentType.Text]: (input) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
            [ContentType.FormData]: (input) => {
                if (input instanceof FormData) {
                    return input;
                }
                return Object.keys(input || {}).reduce((formData, key) => {
                    const property = input[key];
                    formData.append(key, property instanceof Blob ? property : typeof property === 'object' && property !== null ? JSON.stringify(property) : `${property}`);
                    return formData;
                }, new FormData());
            },
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = (_a) => __awaiter(this, void 0, void 0, function* () {
            var { body, secure, path, type, query, format, baseUrl, cancelToken } = _a, params = __rest(_a, ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (requestParams.headers || {})), (type && type !== ContentType.FormData ? { 'Content-Type': type } : {})), signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null, body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body) })).then((response) => __awaiter(this, void 0, void 0, function* () {
                const r = response;
                r.data = null;
                r.error = null;
                const data = !responseFormat
                    ? r
                    : yield response[responseFormat]()
                        .then(data => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch(e => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                if (!response.ok)
                    throw data;
                return data;
            }));
        });
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join('&');
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key]);
        return keys.map(key => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key))).join('&');
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.baseApiParams), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.baseApiParams.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
}
/**
 * @title TorqCloud API
 * @version 1.0.0
 * @baseUrl https://api.torqcloud.io
 *
 * Documentation of API endpoints of TorqCloud
 */
export class TorqcloudApi extends HttpClient {
    constructor() {
        super(...arguments);
        this.schema = {
            /**
             * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
             *
             * @tags schema
             * @name SchemaRetrieve
             * @request GET:/api/schema/
             * @secure
             */
            schemaRetrieve: (query, params = {}) => this.request(Object.assign({ path: `/api/schema/`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * @description Viewset for the Dataset model
             *
             * @tags v1
             * @name V1AppList
             * @request GET:/api/v1/app/
             * @secure
             */
            v1AppList: (params = {}) => this.request(Object.assign({ path: `/api/v1/app/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Viewset for the Dataset model
             *
             * @tags v1
             * @name V1AppCreate
             * @request POST:/api/v1/app/
             * @secure
             */
            v1AppCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/app/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * @description Viewset for the Dataset model
             *
             * @tags v1
             * @name V1AppDestroy
             * @request DELETE:/api/v1/app/{id}/
             * @secure
             */
            v1AppDestroy: (id, params = {}) => this.request(Object.assign({ path: `/api/v1/app/${id}/`, method: 'DELETE', secure: true }, params)),
            /**
             * @description proxy a request to TorqFlow
             *
             * @tags v1
             * @name V1AppTorqFlowRetrieve
             * @request GET:/api/v1/app/torq_flow/
             * @secure
             */
            v1AppTorqFlowRetrieve: (params = {}) => this.request(Object.assign({ path: `/api/v1/app/torq_flow/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Manage email domains for organizations.
             *
             * @tags v1
             * @name V1EmailDomainsList
             * @request GET:/api/v1/email-domains/
             * @secure
             */
            v1EmailDomainsList: (params = {}) => this.request(Object.assign({ path: `/api/v1/email-domains/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Manage email domains for organizations.
             *
             * @tags v1
             * @name V1EmailDomainsCreate
             * @request POST:/api/v1/email-domains/
             * @secure
             */
            v1EmailDomainsCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/email-domains/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * @description Manage email domains for organizations.
             *
             * @tags v1
             * @name V1EmailDomainsDestroy
             * @request DELETE:/api/v1/email-domains/{id}/
             * @secure
             */
            v1EmailDomainsDestroy: (id, params = {}) => this.request(Object.assign({ path: `/api/v1/email-domains/${id}/`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Returns the current user
             *
             * @tags v1
             * @name V1MyInfoRetrieve
             * @request GET:/api/v1/my/info/
             * @secure
             */
            v1MyInfoRetrieve: (params = {}) => this.request(Object.assign({ path: `/api/v1/my/info/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Returns the current user's organizations
             *
             * @tags v1
             * @name V1MyOrganizationsList
             * @request GET:/api/v1/my/organizations/
             * @secure
             */
            v1MyOrganizationsList: (query, params = {}) => this.request(Object.assign({ path: `/api/v1/my/organizations/`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationMembersList
             * @request GET:/api/v1/organization-members/
             * @secure
             */
            v1OrganizationMembersList: (params = {}) => this.request(Object.assign({ path: `/api/v1/organization-members/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationMembersCreate
             * @request POST:/api/v1/organization-members/
             * @secure
             */
            v1OrganizationMembersCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/organization-members/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationMembersRetrieve
             * @request GET:/api/v1/organization-members/{id}/
             * @secure
             */
            v1OrganizationMembersRetrieve: (id, params = {}) => this.request(Object.assign({ path: `/api/v1/organization-members/${id}/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationMembersUpdate
             * @request PUT:/api/v1/organization-members/{id}/
             * @secure
             */
            v1OrganizationMembersUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/api/v1/organization-members/${id}/`, method: 'PUT', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationMembersPartialUpdate
             * @request PATCH:/api/v1/organization-members/{id}/
             * @secure
             */
            v1OrganizationMembersPartialUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/api/v1/organization-members/${id}/`, method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationPermissionsList
             * @request GET:/api/v1/organization-permissions/
             * @secure
             */
            v1OrganizationPermissionsList: (params = {}) => this.request(Object.assign({ path: `/api/v1/organization-permissions/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationPermissionsCreate
             * @request POST:/api/v1/organization-permissions/
             * @secure
             */
            v1OrganizationPermissionsCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/organization-permissions/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationPermissionsDestroy
             * @request DELETE:/api/v1/organization-permissions/{id}/
             * @secure
             */
            v1OrganizationPermissionsDestroy: (id, params = {}) => this.request(Object.assign({ path: `/api/v1/organization-permissions/${id}/`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationsList
             * @request GET:/api/v1/organizations/
             * @secure
             */
            v1OrganizationsList: (params = {}) => this.request(Object.assign({ path: `/api/v1/organizations/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationsCreate
             * @request POST:/api/v1/organizations/
             * @secure
             */
            v1OrganizationsCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/organizations/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationsRetrieve
             * @request GET:/api/v1/organizations/{id}/
             * @secure
             */
            v1OrganizationsRetrieve: (id, params = {}) => this.request(Object.assign({ path: `/api/v1/organizations/${id}/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationsUpdate
             * @request PUT:/api/v1/organizations/{id}/
             * @secure
             */
            v1OrganizationsUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/api/v1/organizations/${id}/`, method: 'PUT', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationsPartialUpdate
             * @request PATCH:/api/v1/organizations/{id}/
             * @secure
             */
            v1OrganizationsPartialUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/api/v1/organizations/${id}/`, method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1OrganizationsBySubscriptionRetrieve
             * @request GET:/api/v1/organizations/by-subscription/
             * @secure
             */
            v1OrganizationsBySubscriptionRetrieve: (params = {}) => this.request(Object.assign({ path: `/api/v1/organizations/by-subscription/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersList
             * @request GET:/api/v1/users/
             * @secure
             */
            v1UsersList: (query, params = {}) => this.request(Object.assign({ path: `/api/v1/users/`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersRetrieve
             * @request GET:/api/v1/users/{id}/
             * @secure
             */
            v1UsersRetrieve: (id, params = {}) => this.request(Object.assign({ path: `/api/v1/users/${id}/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersUpdate
             * @request PUT:/api/v1/users/{id}/
             * @secure
             */
            v1UsersUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/${id}/`, method: 'PUT', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersPartialUpdate
             * @request PATCH:/api/v1/users/{id}/
             * @secure
             */
            v1UsersPartialUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/${id}/`, method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersChangePasswordCreate
             * @request POST:/api/v1/users/change_password/
             * @secure
             */
            v1UsersChangePasswordCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/change_password/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * @description Get the current EULA version and content. Public endpoint - no authentication required. Returns: - version: EULA version string - effective_date: When this version became effective - content: Full EULA markdown content from S3
             *
             * @tags v1
             * @name V1UsersEulaRetrieve
             * @request GET:/api/v1/users/eula/
             * @secure
             */
            v1UsersEulaRetrieve: (params = {}) => this.request(Object.assign({ path: `/api/v1/users/eula/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Automatically join organization based on email domain. Extracts email from authenticated user, finds matching organization via EmailDomain table, verifies email is confirmed, and adds user as a member. Returns: 200: Successfully joined organization 400: Already a member or invalid email 403: Email not verified 404: No organization found for domain
             *
             * @tags v1
             * @name V1UsersJoinOrganizationCreate
             * @request POST:/api/v1/users/join-organization/
             * @secure
             */
            v1UsersJoinOrganizationCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/join-organization/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * @description Look up Cognito username by email for unconfirmed users
             *
             * @tags v1
             * @name V1UsersLookupUsernameRetrieve
             * @request GET:/api/v1/users/lookup-username/
             * @secure
             */
            v1UsersLookupUsernameRetrieve: (query, params = {}) => this.request(Object.assign({ path: `/api/v1/users/lookup-username/`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersMeRetrieve
             * @request GET:/api/v1/users/me/
             * @secure
             */
            v1UsersMeRetrieve: (params = {}) => this.request(Object.assign({ path: `/api/v1/users/me/`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersMeCreate
             * @request POST:/api/v1/users/me/
             * @secure
             */
            v1UsersMeCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/me/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags v1
             * @name V1UsersPermissionsCreate
             * @request POST:/api/v1/users/permissions/
             * @secure
             */
            v1UsersPermissionsCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/permissions/`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * @description Register a new user with EULA acceptance
             *
             * @tags v1
             * @name V1UsersRegisterCreate
             * @request POST:/api/v1/users/register/
             * @secure
             */
            v1UsersRegisterCreate: (data, params = {}) => this.request(Object.assign({ path: `/api/v1/users/register/`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
        };
    }
}
//# sourceMappingURL=torqcloudApi.js.map